module.exports = __webpack_public_path__ + "static/media/Agri-Storage Entrepreneur Infographic mobile 07-02-2023 C.d5ace35b.gif";